import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function ContentActions(props) {
  const { selectedItemsLength, onClickDelete, showFolderSelector } = props;

  if (selectedItemsLength === 0) {
    return null;
  }

  return (
    <div
      data-test="content-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      {selectedItemsLength > 0 && (
        <ToolTipIcon toolText="Move Item">
          <button
            type="button"
            onClick={showFolderSelector}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/paste_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      {selectedItemsLength > 0 && (
        <ToolTipIcon toolText={pluralize('Delete Content', selectedItemsLength)}>
          <button
            type="button"
            onClick={onClickDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
    </div>
  );
}

ContentActions.propTypes = {
  selectedItemsLength: PropTypes.number,
  onClickDelete: PropTypes.func,
  showFolderSelector: PropTypes.func,
};

export default ContentActions;
